import { render } from "./BlockWrap.vue?vue&type=template&id=cf978a06&scoped=true"
import script from "./BlockWrap.vue?vue&type=script&lang=js"
export * from "./BlockWrap.vue?vue&type=script&lang=js"

import "./BlockWrap.vue?vue&type=style&index=0&id=cf978a06&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf978a06"]])

export default __exports__